import React from "react";
import { PageDescription, PageHeader } from "./Layout";
import { Input } from "antd";

export const Banner = ({ title, text }) => {
  return (
    <div style={{ margin: "-47px -40px"}}>
      <PageHeader>
        <div>{title}</div>
        <PageDescription>{text}</PageDescription>
      </PageHeader>
    </div>
  );
};
